import InfoField from '../InfoField';
import PresupuestoOrigenBasics from '../PresupuestoOrigenBasics';
import PiezasList from '../PiezasList';
import { normalizePiezas, sumPrecioVentaPiezas } from '../../utils';

const PresupuestoOrigenFields = ({
    layout,
    origen,
    piezas,
    precioVentaOrigen,
    fechaLabel = 'Fecha',
    clienteDisplay = 'stack',
}) => {
    const piezasList = normalizePiezas({ piezas });
    const multiPieza = piezasList.length > 1;
    const precioVentaTotal =
        precioVentaOrigen ?? sumPrecioVentaPiezas(piezasList);

    return (
        <>
            <PresupuestoOrigenBasics
                origen={origen}
                fechaLabel={fechaLabel}
                clienteDisplay={clienteDisplay}
            />
            {layout === 'atRevision' ? (
                <div className="col-12">
                    <InfoField
                        label={multiPieza ? 'Piezas' : 'Pieza'}
                        value={
                            <PiezasList
                                piezas={piezasList}
                                variant="origen"
                                precioVentaTotal={precioVentaTotal}
                            />
                        }
                    />
                </div>
            ) : null}
            {layout === 'responder' ? (
                <div className="col-12">
                    <InfoField
                        label={multiPieza ? 'Piezas' : 'Pieza'}
                        value={
                            <PiezasList
                                piezas={piezasList}
                                variant="responder"
                                precioVentaTotal={precioVentaTotal}
                            />
                        }
                    />
                </div>
            ) : null}
            {layout === 'sinAlternativa' ? (
                <div className="col-12">
                    <InfoField
                        label={multiPieza ? 'Piezas' : 'Pieza'}
                        value={
                            <div className="d-flex flex-column gap-1">
                                {piezasList.map((pieza) => (
                                    <span key={pieza.id}>
                                        {pieza.nombre ?? '-'}
                                    </span>
                                ))}
                            </div>
                        }
                    />
                </div>
            ) : null}
        </>
    );
};

export default PresupuestoOrigenFields;
